import { useRouter } from 'next/router';
import type { CSSProperties, FC } from 'react';
import React from 'react';

import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';
import { Space } from '@sravni/react-design-system/lib/Space';

import { fullDealLandingPageRoute } from '@src/shared/constants/pageRoutes';
import { MobileAppConvenienceBanner } from 'entities/FullDeal/ui/MobileAppConvenienceBanner';

import {
  FULL_DEAL_MOBILE_APP_LINKS,
  FULL_DEAL_MOBILE_APP_SOURCE,
  getFullDealWebToWebLink,
  getFullDealWebToWebSource,
} from '../../config';
import { buildHasOfferLinkForFullDeal } from '../../lib';
import { ToFullDealAdvertisingButton } from '../ToFullDealAdvertisingButton/ToFullDealAdvertisingButton';

import styles from './FullDealMobileAppActions.module.scss';
import { FullDealMobileAppActionsTexts } from './FullDealMobileAppActions.texts';

export interface FullDealMobileAppActionsProps {
  amount: number;
  term: number;
  toFullDealButtonColor?: ButtonProps['color'];
  className?: string;
  style?: CSSProperties;
}

export const FullDealMobileAppActions: FC<FullDealMobileAppActionsProps> = ({
  amount,
  term,
  style,
  toFullDealButtonColor = 'blue',
  className,
}) => {
  const { asPath } = useRouter();
  const [pathWithoutQuery] = asPath.split('?');
  const isLandingPage = pathWithoutQuery.includes(fullDealLandingPageRoute);

  const linkWebToWeb = getFullDealWebToWebLink(isLandingPage);
  const sourceWebToWeb = getFullDealWebToWebSource(isLandingPage);

  return (
    <Space direction="vertical" size={16} className={styles.container}>
      <MobileAppConvenienceBanner
        amount={amount}
        term={term}
        isLandingPage={isLandingPage}
        variant="dark"
        isUserFromGoogleSearch={false}
      />

      <Space direction="vertical" size={8} className={styles.buttons}>
        <ToFullDealAdvertisingButton
          className={className}
          style={style}
          size={52}
          block
          variant="primary"
          link={FULL_DEAL_MOBILE_APP_LINKS.FROM_LANDING}
          color={toFullDealButtonColor}
          source={FULL_DEAL_MOBILE_APP_SOURCE.FROM_LANDING}
        >
          {FullDealMobileAppActionsTexts.getInApp}
        </ToFullDealAdvertisingButton>

        <ToFullDealAdvertisingButton
          as="link"
          variant="text"
          className={styles.continueButton}
          link={buildHasOfferLinkForFullDeal({
            link: linkWebToWeb,
            amount,
            term,
            showAuth: true,
            ...(isLandingPage && {
              showAuth: true,
              referrer: asPath,
            }),
          })}
          linkTarget="_self"
          size={52}
          source={sourceWebToWeb}
        >
          {FullDealMobileAppActionsTexts.continueWebsite}
        </ToFullDealAdvertisingButton>
      </Space>
    </Space>
  );
};
